const parseBooleanValues = (wrappedValue, summaryTitle) => {
  if (wrappedValue === 'false') return null;
  if (wrappedValue === 'true') return summaryTitle;
  return wrappedValue;
};
export default parseBooleanValues;
